import { THEME } from "../config"

export const handleNumberHelper = (num: number) => {
    if (num === 255 || num === 254) {
        return "-"
    } else {
        return num
    }
}

export const handleStringLengthHelper = (str: string | undefined) => {
    if (!str) return ""
    if (str.length < 25) return str;
    return str.substring(0, 22) + "..."
}

export const capitalizeFirstLetterHelper = (string: string) => {
    return (string.charAt(0).toUpperCase() + string.slice(1)).replace("_", " ").replace("_", " ");
}

export const handleStringHelper = (str: string | undefined) => {
    if (str === undefined) return "-"
    return capitalizeFirstLetterHelper(replaceAllHelper(str.toLowerCase(), "_", " "))
}

export const handleCutStringHelper = (cut: string | undefined, str: string | undefined) => {
    if (str === undefined) return "-"
    if (cut && str.startsWith(cut)) {
        str = str.slice(cut.length)
    }
    return capitalizeFirstLetterHelper(replaceAllHelper(str.toLowerCase(), "_", " "))
}

export const handleParseList = (prefix: string, arr: string[]): string => {
    return arr.map(i => handleCutStringHelper(prefix, i)).join(", ")
}

export const handleSubjectStringHelper = (str: string | undefined) => {
    if (str === undefined) return "-"
    return str
}

export const numbersToString = (arr: number[], sep = ","): string => {
  return arr.join(sep);
}

export const handleDate = (dateValue: any, isMobile: boolean) => {
    if (isMobile) {
        return new Date(dateValue).toISOString().split( "T" )[0];
    } else {
        return new Date(dateValue).toUTCString()
    }
}

export const replaceAllHelper = (str: string, find: string, replace: string) => {
    return str.replace(new RegExp(find, 'g'), replace);
}

export const selectHTTPColorHelper = (num: number) => {
    if (num >= 500) {
        return THEME.palette.error.main
    } else {
        return THEME.palette.warning.main
    }
}

export const handleStringFromLastOccurrence = (str: string, char: string) => {
    return str.substring(str.lastIndexOf(char) + 1)
}